import React, { useState, useEffect, useRef } from "react";
import { SetHeading } from "../../context/NavbarContext";
import { Breadcrumb, Button, Drawer } from "antd";
import { DoubleRightOutlined, DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  fetchAllVendors,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import { createNewCustomer, GetAllCustomers, getCustomers, updateExistingCustomer } from "../../API  Functions/SessionHistoryFunctions";
import CreditHistoryTable from "./CreditHistoryTable";
import ExportCasInOutReportModal from "./ExportCasInOutReportModal";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import i18next from "i18next";
import SelectBox from "../../components/CustomWidgets/SelectBox";
import { getCreditPaymentHistory } from "../../API  Functions/CashierFunctions";
import moment from "moment";
import { checkPermission } from "../../Utils/permissionHelper";
import CustomersTable from "./CustomersTable";
import AddCustomerModal from "../../modals/AddCustomerModal";
import ImportCustomers from "./ImportCustomers";

const AllCustomers = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);

  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [query, setquery] = useState("");
  const [creditHistoryData, setCreditHistoryData] = useState([]);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isOpenImportCustomer, setIsOpenImportCustomer] = useState(false)
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );

  const [selectedPaymentType, setSelectedPaymentType] = useState(
    t("All")
  );

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )


  const [paymentHistoryData, setPaymentHistoryData] = useState([]);
  const [drawerData, setDrawerData] = useState(null);
  const [visible, setVisible] = useState(false);
  const [openAddCustomer, setOpenAddCustomer] = useState(false);
  const printRef = useRef();



  const options = [
    {
      value: "",
      label: `${t("All")}`,
    },
    {
      value: "paid",
      label: `${t("Paid")}`,
    },
    {
      value: "unpaid",
      label: `${t("Unpaid")}`,
    },
  ];

  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  useEffect(() => {
    GetAllCustomers(query, selectedPaymentType);
  }, [currentLimit, currentOffset]);



  const GetAllCustomers = async (text, type = selectedPaymentType) => {
    const payload = {
      offset: currentOffset,
      limit: currentLimit,
      store_id: company_id,
      search: text,
      type: type || "", // fallback to empty string
    };

    try {
      const res1 = await getCustomers(payload);
      if (res1?.result?.status_code == 200) {
        setCreditHistoryData(res1?.result?.customer_list);
      } else {
        setCreditHistoryData([]);
      }
    } catch (error) {
      console.error("Error fetching Credit History data:", error);
    } finally {
      setloading(false);
    }
  };

  const debouncedSearch = debounce((value) => {
    setSelectedPaymentType("")
    setloading(true)
    console.log("value---------->", value);

    GetAllCustomers(value);
  }, 1000);
  console.log("creditHistoryData", creditHistoryData);



  const handlePaymentTypeChange = (event) => {
    const paymentType = event.target.value;
    setloading(true);
    setquery("");
    setSelectedPaymentType(paymentType);
    GetAllCustomers("", paymentType); // Pass type exp licitly
  };



  const getPaymentHistory = (pos_credit_id) => {
    const payload = {
      pos_credit_id: pos_credit_id,
    };
    getCreditPaymentHistory(payload)
      .then((res) => {

        console.log("FHFHFHFBF-->", res);

        if (res?.result[0]?.response.length > 0) {
          setPaymentHistoryData(res?.result[0]?.response);
          setloading(false);
        } else {
          setPaymentHistoryData([]);
          console.error("No session history found");
        }
      })
      .catch((error) => {
        console.error("Error fetching session history:", error);
      });
  };



  const handleExport = async () => {
    let payload = {
      lang: i18next.language === 'ar' ? 'ar_001' : 'en_US',
      start_date: '2023-01-01',
      end_date: getCurrentDate(),
      search: "",
      company_id: company_id
    };
    const response = await axiosInstance.post(
      URLS.CREDIT_HISTORY_EXCEL,
      payload
    );
    console.log("handleExport", response?.data?.result);
    if (response?.data?.result?.status_code == 200) {
      setExportModalOpen(false)
      downloadFile(response?.data?.result?.file);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      const timestamp = new Date()
        .toISOString()
        .replace(/[:.]/g, "-")
        .replace("T", "_")
        .slice(0, 19);
      const filename = `credit_history_${timestamp}.${fileExtension}`;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  const showDrawer = (historyData) => {
    console.log("HISSSSS", historyData);

    setDrawerData(historyData);
    setVisible(true);
    getPaymentHistory(historyData.pos_credit_id);
    // setSelectedUserId(historyData.bill_id);
  };


  const onClose = () => {
    setVisible(false);
  };

  const CreateCustomer = async (data) => {
    setloading(true);
    const payload = {
      "store_id": company_id,
      "user_id": user_id,
      "phone": data?.mobile,
      "name": data?.userName,
      "email": "",
      "address_type_id": data?.address_type_id,
      "add_field_1": data?.add_field_1,
      "add_field_2": data?.add_field_2,
      "add_field_3": data?.add_field_3,
      "add_field_4": data?.add_field_4,
      "credit_amount": data?.credit_amount,
      "credit_as_on_date": data?.credit_as_on_date,
    };

    try {
      const res1 = await createNewCustomer(payload);
      if (res1?.result?.status_code == 200) {
        toast.success(t(res1?.result?.status))
        setOpenAddCustomer(false)
        GetAllCustomers(query, selectedPaymentType);
      } else {
        toast.error(t(res1?.result?.status))
      }
    } catch (error) {
      console.error("Error fetching Credit History data:", error);
    } finally {
      setloading(false);
    }
  }

  const UpdateCustomer = async (data) => {
    setloading(true);
    const payload = {
      "store_id": company_id,
      "user_id": user_id,
      "phone": data?.mobile,
      "name": data?.userName,
      "customer_id": data?.customer_id,
      "email": "",
      "address_type_id": data?.address_type_id,
      "add_field_1": data?.add_field_1,
      "add_field_2": data?.add_field_2,
      "add_field_3": data?.add_field_3,
      "add_field_4": data?.add_field_4,
      "credit_amount": data?.credit_amount,
      "credit_as_on_date": data?.credit_as_on_date,
    };

    try {
      const res1 = await updateExistingCustomer(payload);
      if (res1?.result?.status_code == 200) {
        toast.success(t(res1?.result?.status))
        setOpenAddCustomer(false)
        GetAllCustomers(query, selectedPaymentType);
      } else {
        toast.error(t(res1?.result?.status))
      }
    } catch (error) {
      console.error("Error fetching Credit History data:", error);
    } finally {
      setloading(false);
    }
  }


  const handlePrint = () => {
    const content = printRef.current.innerHTML;

    const printWindow = window.open("", "", "width=800,height=600");

    printWindow.document.write(`
    <html>
      <head>
        <title>Customer Credit</title>
        <style>
          @page {
            margin: 10mm;
          }

          @media print {
            body {
              zoom: 0.75;
            }
          }

          body {
            font-family: Arial;
            font-size: 12px;
            color: #000;
          }

          .container {
            width: 100%;
          }

          h2 {
            font-size: 16px;
            text-align: center;
            margin-bottom: 6px;
          }

          h3 {
            font-size: 13px;
            margin: 8px 0 4px;
          }

          p {
            margin: 2px 0;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 6px;
          }

          th, td {
            border: 1px solid #ccc;
            padding: 4px;
            font-size: 11px;
          }

          th {
            background: #f0f0f0;
          }
        </style>
      </head>
      <body>
        <div class="container">
          ${content}
        </div>
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };


  const thStyle = {
    border: "1px solid #ccc",
    padding: "8px",
    background: "#f5f5f5",
    textAlign: "left",
  };

  const tdStyle = {
    border: "1px solid #ccc",
    padding: "8px",
  };


    const handleExportCustomers = async () => {
    let payload = {
    store_id: company_id,
    "search":"", //with name, phone or email
    "type":selectedPaymentType, // paid / unpaid
   lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };

    try {
      const response = await axiosInstance.post(
        URLS.GET_EXCEL_ALL_CUSTOMERS,
        payload
      );
console.log("fd====>",response?.data?.result);

      if (response?.data?.result?.status_code == 200) {
        downloadCustomersFile(response?.data?.result?.file);
      } else {
        toast.error(response?.data?.result?.status || t("Export failed"));
      }
    } catch (error) {
      console.error("POS orders export failure:", error);
      toast.error(t("Something went wrong while exporting"));
    }
  };  

  const downloadCustomersFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      // const timestamp = new Date()
      //   .toISOString()
      //   .replace(/[:.]/g, "-")
      //   .replace("T", "_")
      //   .slice(0, 19);
      // const filename = `cashier_orders_${timestamp}.${fileExtension}`;
      const timestamp = moment().format('YYYY-MM-DD_HH.mm.ss'); // Using period for time
      const filename = `${t('all_customers')}_${timestamp}.${fileExtension}`;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };


  return (
    <>
      <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
        <SetHeading value="Customers" />
        <div className="custom-scrollbar ms-1 flex-grow overflow-y-auto overflow-hidden sm:ms-3">
          {/* <div className="font-extrabold mb-3">
            <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: <Link to={routes.purchase}>{t("Cashier")}</Link>,
                  key: "purchase",
                },
                { title: t("Credit History") },
              ]}
              className="relative mt-3 font-semibold"
            />
          </div> */}
          <div className="me-1 mt-4 flex flex-col gap-3 sm:me-3 md:me-8 md:flex-row md:items-start md:justify-between">
            <div className="flex w-full flex-col gap-2 md:w-auto md:flex-row">
              <SearchBox
                // showBarcode={true}
                value={query}
                searchResult={(values) => {
                  setquery(values);
                  debouncedSearch(values)
                }}
                placeholder={t("Search Name/Phone Number")}
              />
              <div className="mb-2 w-full md:ms-3 md:w-[50%]">
                <SelectBox
                  // style={{ width: 40 }}
                  // width={140}
                  placeholder={"all_orders"}
                  name="filter"
                  onChange={handlePaymentTypeChange}
                  options={options}
                  value={selectedPaymentType}
                />
              </div>
            </div>
            <div className="flex w-full gap-2 md:w-auto">
              <button
                className="mt-2 flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-44 md:mt-2"
                onClick={() => setIsOpenImportCustomer(true)}
              >
                <UploadOutlined />
                {t("Import")}
              </button>
                <button
                              className="mt-2 flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-48"
                              // onClick={() => setExportModalOpen(true)}
                              onClick={() => {
                                  handleExportCustomers();
                              }}
                            >
                              <DownloadOutlined
                                style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                              />
              
                              <span>{t("Download in Excel")}</span>
                            </button>
              <button
                className="mt-1 flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-44 md:mt-2"
                onClick={() => {
                  if (allStores) {
                    // If allStores is true, directly call handleExport
                    setOpenAddCustomer(true);
                  } else {
                    // Otherwise, check permission before calling handleExport
                    if (checkPermission("/pos/credithistory", isGinne)) {
                      setOpenAddCustomer(true);
                    }
                  }
                }}
              >
                <span>{t("Add Customer")}</span>
              </button>
              {/* <button
              className="w-48 h-10 bg-primaryBlue mt-2 text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
              // onClick={() => handleExport()}
              // onClick={() => {
              //   if (checkPermission("/pos/credithistory", isGinne)) {
              //     handleExport();
              //   }
              // }}
              onClick={() => {
                if (allStores) {
                  // If allStores is true, directly call handleExport
                  handleExport();
                } else {
                  // Otherwise, check permission before calling handleExport
                  if (checkPermission("/pos/credithistory", isGinne)) {
                    handleExport();
                  }
                }
              }}
            >
              <DownloadOutlined
                style={{ fontSize: "1.5em", MozMarginStart: -10 }}
              />

              <span>{t("Download in Excel")}</span>
            </button> */}
            </div>

          </div>

          {loading ? (
            <ShimmerLoader />
          ) : (
            <>
              <div className="mt-3">
                <CustomersTable
                  additionalData={creditHistoryData}
                  pagination={(values) => {
                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                  }}
                  showDrawer={showDrawer}
                  onEditLine={(data) => {
                    setEditData(data);
                    setOpenAddCustomer(true);
                  }}
                />
              </div>
            </>
          )}
        </div>
        {exportModalOpen && (
          <ExportCasInOutReportModal
            heading={t('Download Credit History Report')}
            isOpen={exportModalOpen}
            onClose={() => setExportModalOpen(false)}
            onExport={(dates) => handleExport(dates)}
          />
        )}
        {openAddCustomer &&
          <AddCustomerModal
            onClose={() => {
              setEditData(null);
              setOpenAddCustomer(false)
            }}
            confirm={(data) => { CreateCustomer(data) }}
            showSkipButton={true}
            editData={editData ? editData : null}
            onUpdate={(data) => { UpdateCustomer(data) }}
            loading={loading}
          />
        }
        {
          isOpenImportCustomer &&
          <ImportCustomers

            onClose={() => setIsOpenImportCustomer(false)}
            isOpen={isOpenImportCustomer}
          />
        }

      </div>
      <Drawer
        title={t("Payment History")}
        placement="right"
        width={typeof window !== "undefined" && window.innerWidth < 768 ? "95%" : 700}
        onClose={onClose}
        visible={visible}
      >
        {loading ? (
          <div>{t("Loading session data...")}</div>
        ) : (
          <div>
            <div className="flex justify-end mb-4">
              <button
                onClick={handlePrint}
                className="px-6 py-2 bg-[#1b4597] text-white rounded-lg -mt-2 font-semibold"
              >
                {t("Print")}
              </button>
            </div>
            {paymentHistoryData.length > 0 ? (
              <>
                <div className="overflow-x-auto">
                  <table className="min-w-[620px] w-full">
                    <thead>
                      <tr className="bg-gray-200">
                        <th className="p-2 text-start">{t("Payment Date & Time")}</th>
                        <th className="p-2 text-start">{t("amount")}</th>
                        <th className="p-2 text-start">{t("Remark")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentHistoryData.map((payment, index) => (
                        <tr key={index} className="border-b">
                          <td className="p-2">
                            {/* {moment(payment.payment_date).format("YYYY-MM-DD")} */}
                            {moment(payment.payment_date).format("YYYY-MM-DD HH:mm:ss")}
                          </td>
                          <td className="p-2">{"EGP"} {payment.paid_amount}</td>
                          <td className="p-2">{t(payment.remark)}</td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <p>{t("No payment history available")}</p>
            )}
          </div>
        )}
      </Drawer>

      <div style={{ display: "none" }}>
        <div ref={printRef}>

          <h2>{t("Customer Details")}</h2>

          <p><strong>{t("Name")}:</strong> {drawerData?.customer_name}</p>
          <p><strong>{t("Phone")}:</strong> {drawerData?.mobile_no}</p>
          <p><strong>{t("Address")}:</strong> {drawerData?.address}</p>

          <h3>{t("Payment History")}</h3>

          <table>
            <thead>
              <tr>
                <th style={thStyle}>{t("Date")}</th>
                <th style={thStyle}>{t("Paid")}</th>
                <th style={thStyle}>{t("Remark")}</th>
              </tr>
            </thead>
            <tbody>
              {paymentHistoryData.map((payment, index) => (
                <tr key={index}>
                  <td style={tdStyle}>
                    {moment(payment.payment_date).format("YYYY-MM-DD HH:mm")}
                  </td>
                  <td style={tdStyle}>
                    EGP {payment.paid_amount}
                  </td>
                  <td style={tdStyle}>
                    {payment.remark || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AllCustomers;
